// Redux actions for async inspection-doc zip exports.
import axios from "axios";

const prepareData = (data) => {
  return { project_qa_assembly_export: data };
};

export const GET_PROJECT_QA_ASSEMBLY_EXPORTS = "get_project_qa_assembly_exports";
export const getProjectQaAssemblyExports = (project_id) => {
  const request = axios.get(`/project/${project_id}/qa/assembly_exports.json`);
  return {
    type: GET_PROJECT_QA_ASSEMBLY_EXPORTS,
    payload: request,
  };
};

export const GET_PROJECT_QA_ASSEMBLY_EXPORT = "get_project_qa_assembly_export";
export const getProjectQaAssemblyExport = (project_id, id) => {
  const request = axios.get(`/project/${project_id}/qa/assembly_exports/${id}.json`);
  return {
    type: GET_PROJECT_QA_ASSEMBLY_EXPORT,
    payload: request,
  };
};

export const CREATE_PROJECT_QA_ASSEMBLY_EXPORT = "create_project_qa_assembly_export";
export const createProjectQaAssemblyExport = (project_id, data) => {
  const request = axios({ method: "post", url: `/project/${project_id}/qa/assembly_exports.json`, data: prepareData(data) });
  return {
    type: CREATE_PROJECT_QA_ASSEMBLY_EXPORT,
    payload: request,
  };
};
